var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section", attrs: { id: "orders" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "details" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "column flex-1" }, [
            _c("b", [_vm._v("Nome do cliente")]),
            _vm._v(" "),
            _vm.dayFormated
              ? _c("span", [_vm._v("Dia: " + _vm._s(_vm.dayFormated))])
              : _vm._e(),
            _vm._v(" "),
            _vm.dayOfWeek
              ? _c("span", [_vm._v("Dia da semana: " + _vm._s(_vm.dayOfWeek))])
              : _vm._e(),
            _vm._v(" "),
            _vm.frequency
              ? _c("span", [_vm._v("Frequencia: " + _vm._s(_vm.frequency))])
              : _vm._e(),
            _vm._v(" "),
            _c("span", [_vm._v("Horário: " + _vm._s(_vm.startAtFormated))]),
            _vm._v(" "),
            _c("span", [_vm._v("Duração: " + _vm._s(_vm.duration) + "h")])
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "column flex-1" }, [
            _c("b", [_vm._v("Limpeza")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "Profissional: " +
                  _vm._s(_vm.professional ? _vm.professional.name : "")
              )
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("Valor: " + _vm._s(_vm.price.formated))]),
            _vm._v(" "),
            _c("span", [_vm._v("Produtos: " + _vm._s(_vm.textTakeProducts))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "informations mt-20" }, [
          _vm._v("Informações:\n      "),
          _c("p", [_vm._v(_vm._s(_vm.information))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-center" }, [
          _c(
            "div",
            {
              staticClass: "btn bg-pink pl-30 pr-30",
              on: {
                click: function($event) {
                  _vm.confirmed = true
                }
              }
            },
            [_vm._v("confirmar")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _vm.confirmed
          ? _c("div", { staticClass: "btn bg-pink pl-30 pr-30 mt-50" }, [
              _vm._v(
                _vm._s(
                  _vm.dayOfWeek
                    ? "enviar solicitação"
                    : "enviar link de pagamento"
                )
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _vm._v("CONFIRME SEU PEDIDO\n    "),
      _c("hr")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column flex-1" }, [
      _c("b", [_vm._v("Local")]),
      _vm._v(" "),
      _c("span", [_vm._v("CASA")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("Rua General Argolo, 315 | Apto 507 | Centro - Pelotas/RS")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a04d6a20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a04d6a20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/OrdersAndSubscriptions/Confirm.vue
// module id = null
// module chunks = 